const translations = {
    ready: 'Airworthy'
};

export default translations;
